import styled, { css } from 'styled-components'

import { Rect } from 'modules/shares/types'

export const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

interface LayerOverlayProps {
  frame: Rect
}

export const LayerOverlay = styled.div<LayerOverlayProps>(
  ({ frame }) => css`
    position: absolute;
    top: ${frame.y}px;
    left: ${frame.x}px;
    width: ${frame.width}px;
    height: ${frame.height}px;
  `
)
